import React from 'react';
import { Stack } from '@moda/om';
import './FormButtonsLayout.scss';

type Props = {
  align?: 'left' | 'right';
  children?: React.ReactNode;
};

export const FormButtonsLayout: React.FC<Props> = ({ align = 'right', children }) => (
  <Stack
    className="FormButtonsLayout"
    direction="horizontal"
    justifyContent={align === 'right' ? 'flex-end' : 'flex-start'}
    alignItems="center"
    space={2}
  >
    {children}
  </Stack>
);
